<style scoped>
.br-10 {
  border-radius: 10px;
}
</style>

<template>
  <v-container fluid>
    <span class="text-caption" v-if="loading">{{ $t('searching') }}</span>
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <br v-if="loading" />
    <v-alert v-if="error" id="error" :value="error !== null" class="br-10 dark font-weight-medium" type="error" dismissible>{{ error.message | uppercase }}</v-alert>
    <v-layout justify-center pb-3>
      <v-flex xl6 lg6 md8 sm10 xs12>
        <v-card class="br-10 pa-8 elevation-3" color="blue lighten-4">
          <v-form @submit.prevent="searchData()">
            <span class="caption"><h2>{{ $t('page_compound.index.header') }}</h2></span>
            <v-text-field :value="data.searchId" @input="patchData({ searchId: $event })" :placeholder="$t('searches')"/>
            <span class="caption"><strong>{{ $t('page_compound.index.hint') }}</strong></span>
            <v-layout reverse row class="mt-2">
              <v-btn :disabled="data === {} || data.searchId === undefined || data.searchId === ''" large rounded color="primary" type="submit">{{ $t('page_compound.index.search') }}</v-btn>
            </v-layout>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex xl6 lg6 md8 sm10 xs12>
        <v-list v-if="listData.length > 0" three-line class="br-10 elevation-3">
          <v-subheader class="black--text"><h3>{{ $t('page_compound.index.result') }}</h3></v-subheader>
          <v-divider/>
          <div v-for="item in listData" :key="item._id">
            <v-list-item>
              <v-list-item-action class="pl-2 pt-2">
                <v-checkbox :value="item._id" :input-value="data._id" @click.native="setData({ data: { _id: item._id } })"/>
              </v-list-item-action>
              <v-list-item-content @click.stop="setData({ data: { _id: item._id } })">
                <v-list-item-title class="body-2"><strong>{{ $t('page_compound.index.compound_date') }} : {{ data.compound_date | dateTime }} </strong></v-list-item-title>
                <v-list-item-subtitle><h4>{{ $t('page_compound.index.compound_type') }} : {{ $t(`page_compound.index.${item.bill_type}`) }}</h4></v-list-item-subtitle>
                <v-list-item-subtitle><h4>{{ $t('page_compound.index.compound_no') }} : {{ item.bill_reference }}</h4></v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-layout v-if="listData.length > 0" reverse row class="pr-4">
            <v-btn :disabled="data._id === undefined || data._id === ''" @click="payOnline(data)" class="mt-3" color="primary" large nuxt align-right rounded>{{ $t('page_compound.index.proceed') }}</v-btn>
          </v-layout>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import vuex from 'vuex'
import configuration from '../../configurations/index'

export default {
  beforeDestroy () {
    this.$store.commit('search/setError', { error: null })
    this.$store.commit('search/setLoading', { loading: false })
  },
  beforeMount () {
    this.$store.commit('search/setListData', { listData: [] })
  },
  computed: {
    ...vuex.mapState({
      data: state => state.search.data,
      error: state => state.search.error,
      loading: state => state.search.loading,
      listData: state => state.search.listData
    })
  },
  methods: {
    ...vuex.mapActions({
      patchData: 'search/patchData',
      resetData: 'search/resetData',
      searchData: 'search/searchData'
    }),
    ...vuex.mapMutations({
      setData: 'search/setData'
    }),
    payOnline (data) {
      if (!window.hasOwnProperty('cordova')) {
        window.location.href = `${configuration.host.epayment}/#/confirmation?_id=${
          btoa(data._id)
        }&council=mpt&payment_type=compound&compound_type=${
          data.compound_type
        }`
        return
      }
      let ref = cordova.InAppBrowser.open(`${configuration.host.epayment}/#/confirmation?_id=${
        btoa(data._id)
      }&council=mpt&payment_type=compound&compound_type=${
        data.compound_type
      }`, '_self', 'location=no,enableViewportScale=yes,zoom=no')
      let params = ''
      ref.addEventListener('loadstop', function (event) {
        if (event.url.substring(0, 41) === `${configuration.host.epayment}/#/receipt?`) {
          params = event.url.substring(41, event.url.length)
          ref.close()
          this.$router.push('/receipt?' + params)
        }
        if (event.url === `${configuration.host.epayment}/#/index.html#/` || event.url === `${configuration.host.epayment}/#/`) {
          ref.close()
          this.$router.push('/')
        }
      }.bind(this))
    }
  }
}
</script>
